import { render, staticRenderFns } from "./TablaNoSeriada.vue?vue&type=template&id=788f1a1c&"
import script from "./TablaNoSeriada.vue?vue&type=script&lang=ts&"
export * from "./TablaNoSeriada.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports